// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.checkout.CheckoutTaskResponse */
/* istanbul ignore next */
@GandalfModel
export class CheckoutTaskResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: String })
	createdBy!: string | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isAssigned!: boolean | null;

	@GandalfProperty({ designType: String })
	recallLocationName!: string | null;

	@GandalfConstantDecorator(constants.CheckoutTaskStatus)
	@GandalfProperty({ designType: constants.CheckoutTaskStatus })
	status!: constants.CheckoutTaskStatus | null;

}
